import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable max-lines */
import { Button } from '@cian/button-component';
import { Link } from '@cian/link-component';
import * as React from 'react';
import { EEventType } from '../../types/events';
import { EActiveView } from '../../types/view';
import { EKeyCode } from '../../types/keyCodes';
import { EAuthenticateError, EAuthenticateStatus, ETwoFactorStatus, ETwoFactorType } from '../../types/authentication';
import { isEmail, isValidPhone } from '../../utils/validation';
import { FormItem } from '../FormItem';
import { Timer } from '../Timer';
import { ViewContainer } from '../../containers/ViewContainer';
import * as styles from './styles.css';
import { trackTwoFactorCannotConfirmClick, trackTwoFactorClose, trackTwoFactorContinueClick, trackTwoFactorPopupOpen, trackTwoFactorResendClick, trackTwoFactorWhatForClick } from '../../utils/tracking';
export var TwoFactorView = /*#__PURE__*/function (_React$Component) {
  _inherits(TwoFactorView, _React$Component);

  var _super = _createSuper(TwoFactorView);

  function TwoFactorView() {
    var _this;

    _classCallCheck(this, TwoFactorView);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "phoneField", /*#__PURE__*/React.createRef());

    _defineProperty(_assertThisInitialized(_this), "codeField", /*#__PURE__*/React.createRef());

    _defineProperty(_assertThisInitialized(_this), "state", {
      phone: '',
      code: '',
      isChanged: false,
      isPhoneInvalid: false,
      isCodeInvalid: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleWhatForClick", function () {
      trackTwoFactorWhatForClick(ETwoFactorType.Sms);

      _this.props.emit(EEventType.TwoFactorWhatForClick);
    });

    _defineProperty(_assertThisInitialized(_this), "handlePhoneKeyDown", function (event) {
      if (event.keyCode === EKeyCode.Enter) {
        _this.submit();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handlePhoneValueChange", function (phone) {
      _this.setState({
        phone: phone,
        isChanged: true,
        isPhoneInvalid: !!phone && !isValidPhone(phone)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleCodeKeyDown", function (event) {
      if (event.keyCode === EKeyCode.Enter) {
        _this.submit();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleCodeValueChange", function (code) {
      _this.setState({
        code: code,
        isChanged: true,
        isCodeInvalid: !code || code.length < 4
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubmitClick", function (event) {
      event.preventDefault();
      trackTwoFactorContinueClick(ETwoFactorType.Sms);

      _this.submit();
    });

    _defineProperty(_assertThisInitialized(_this), "submit", function () {
      var _this$props = _this.props,
          _this$props$authentic = _this$props.authentication,
          authenticateStatus = _this$props$authentic.authenticate.status,
          twoFactorStatus = _this$props$authentic.twoFactor.status,
          emit = _this$props.emit;

      if ([EAuthenticateStatus.Loading, EAuthenticateStatus.Succeed].includes(authenticateStatus)) {
        return;
      }

      if (twoFactorStatus === ETwoFactorStatus.Loading) {
        return;
      }

      var phoneRaw = _this.state.phone;
      var phone = isValidPhone(phoneRaw) ? "+".concat(phoneRaw.replace(/\D+/g, '')) : '';

      if (twoFactorStatus !== ETwoFactorStatus.Succeed) {
        if (!phone) {
          _this.setState({
            isPhoneInvalid: true
          });

          return;
        }

        _this.setState({
          isChanged: false
        });

        _this.props.sendTwoFactorCode(phone);
      } else {
        var _code = _this.state.code;

        if (!_code || _code.length < 4) {
          _this.setState({
            isCodeInvalid: true
          });

          if (_this.codeField.current) {
            _this.codeField.current.focus();
          }

          return;
        }

        _this.setState({
          isChanged: false
        });

        _this.props.authenticate(phone, _code);
      }

      emit(EEventType.TwoFactorContinueClick);
    });

    _defineProperty(_assertThisInitialized(_this), "handleTimeout", function () {
      _this.setState({
        codeResendAvailable: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleResendClick", function (event) {
      event.preventDefault();
      var _this$props2 = _this.props,
          status = _this$props2.authentication.twoFactor.status,
          sendTwoFactorCode = _this$props2.sendTwoFactorCode,
          emit = _this$props2.emit;
      trackTwoFactorResendClick(ETwoFactorType.Sms);

      if (status !== ETwoFactorStatus.Succeed) {
        return;
      }

      var phone = _this.state.phone;

      _this.setState({
        isChanged: true,
        isCodeInvalid: false,
        code: ''
      });

      sendTwoFactorCode("+".concat(phone.replace(/\D+/g, '')));
      emit(EEventType.TwoFactorResendClick);
    });

    _defineProperty(_assertThisInitialized(_this), "handleCannotConfirmClick", function () {
      trackTwoFactorCannotConfirmClick(ETwoFactorType.Sms);

      _this.props.emit(EEventType.TwoFactorCannotConfirmClick);
    });

    _defineProperty(_assertThisInitialized(_this), "handleBackClick", function () {
      var _this$props3 = _this.props,
          login = _this$props3.login,
          reset = _this$props3.reset,
          changeLogin = _this$props3.changeLogin;
      reset();
      trackTwoFactorClose(ETwoFactorType.Sms);
      changeLogin(login);
    });

    return _this;
  }

  _createClass(TwoFactorView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.phoneField.current) {
        this.phoneField.current.focus();
      }

      trackTwoFactorPopupOpen(ETwoFactorType.Sms);
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.authentication.twoFactor.status !== nextProps.authentication.twoFactor.status) {
        switch (nextProps.authentication.twoFactor.status) {
          case ETwoFactorStatus.Failed:
            this.setState({
              codeSentDate: undefined,
              codeResendAvailable: undefined
            });
            break;

          case ETwoFactorStatus.Succeed:
            this.setState({
              codeSentDate: new Date(),
              codeResendAvailable: false
            });
            break;
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.authentication.twoFactor.status !== this.props.authentication.twoFactor.status) {
        if (this.props.authentication.twoFactor.status === ETwoFactorStatus.Succeed) {
          if (this.codeField.current) {
            this.codeField.current.focus();
          }
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          login = _this$props4.login,
          _this$props4$authenti = _this$props4.authentication,
          authenticateStatus = _this$props4$authenti.authenticate.status,
          _this$props4$authenti2 = _this$props4$authenti.twoFactor,
          twoFactorStatus = _this$props4$authenti2.status,
          twoFactorError = _this$props4$authenti2.error;
      var _this$state = this.state,
          phone = _this$state.phone,
          isChanged = _this$state.isChanged,
          isPhoneInvalid = _this$state.isPhoneInvalid;
      var isPhoneDisabled = twoFactorStatus === ETwoFactorStatus.Loading || twoFactorStatus === ETwoFactorStatus.Succeed;
      var isSubmitDisabled = [EAuthenticateStatus.Loading, EAuthenticateStatus.Succeed].includes(authenticateStatus) || twoFactorStatus === ETwoFactorStatus.Loading;
      var contactQuery = [isEmail(login) ? "email=".concat(encodeURIComponent(login)) : null, phone && isValidPhone(phone) ? "phone=".concat(encodeURIComponent("+".concat(phone.replace(/\D+/g, '')))) : null, 'twoFactor=true'].filter(Boolean).join('&');
      return /*#__PURE__*/React.createElement(ViewContainer, {
        prevView: EActiveView.AuthenticationRegistration,
        onBack: this.handleBackClick
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles['header']
      }, "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u0432\u0445\u043E\u0434\u0430"), /*#__PURE__*/React.createElement("p", {
        className: styles['description']
      }, "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u043D\u044B\u0439 \u0442\u0435\u043B\u0435\u0444\u043E\u043D \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430 \u0438\u043B\u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u0443\u043A\u0430\u0437\u0430\u043D \u0432 \u0432\u0430\u0448\u0435\u043C \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0438. \u0422\u043E\u043B\u044C\u043A\u043E \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u044B\u0435 \u043D\u043E\u043C\u0435\u0440\u0430.", ' ', /*#__PURE__*/React.createElement(Link, {
        href: "/help/security/37947/",
        target: "_blank",
        onClick: this.handleWhatForClick
      }, "\u0417\u0430\u0447\u0435\u043C \u044D\u0442\u043E \u043D\u0443\u0436\u043D\u043E")), /*#__PURE__*/React.createElement("div", {
        className: styles['phone_row']
      }, /*#__PURE__*/React.createElement(FormItem, {
        ref: this.phoneField,
        id: "two_factor-phone",
        label: "\u041F\u043E\u043B\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430",
        value: phone,
        mask: "+7 (999) 999 9999",
        alwaysShowMask: true,
        error: twoFactorStatus === ETwoFactorStatus.Failed && !isChanged ? twoFactorError : undefined,
        invalid: twoFactorStatus === ETwoFactorStatus.Failed && !isChanged || isPhoneInvalid,
        disabled: isPhoneDisabled,
        maskChar: "\u2219",
        onKeyDown: this.handlePhoneKeyDown,
        onValueChange: this.handlePhoneValueChange
      })), this.renderCodeRow(), /*#__PURE__*/React.createElement("div", {
        className: styles['submit_row']
      }, /*#__PURE__*/React.createElement(Button, {
        type: "submit",
        isSync: isSubmitDisabled,
        onClick: this.handleSubmitClick
      }, "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C"), /*#__PURE__*/React.createElement(Link, {
        href: "/contacts/?".concat(contactQuery),
        target: "_blank",
        className: styles['cancel'],
        onClick: this.handleCannotConfirmClick
      }, "\u041D\u0435 \u043C\u043E\u0433\u0443 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C")));
    }
  }, {
    key: "renderCodeRow",
    value: function renderCodeRow() {
      var _this$props$authentic2 = this.props.authentication,
          twoFactorStatus = _this$props$authentic2.twoFactor.status,
          _this$props$authentic3 = _this$props$authentic2.authenticate,
          authenticateStatus = _this$props$authentic3.status,
          authenticateErrorType = _this$props$authentic3.errorType,
          authenticateError = _this$props$authentic3.error;
      var _this$state2 = this.state,
          code = _this$state2.code,
          codeSentDate = _this$state2.codeSentDate,
          codeResendAvailable = _this$state2.codeResendAvailable,
          isChanged = _this$state2.isChanged,
          isCodeInvalid = _this$state2.isCodeInvalid;
      var isCodeVisible = twoFactorStatus === ETwoFactorStatus.Succeed || twoFactorStatus !== ETwoFactorStatus.Failed && codeResendAvailable;

      if (!isCodeVisible) {
        return null;
      }

      var isError = authenticateStatus === EAuthenticateStatus.Failed && authenticateErrorType !== EAuthenticateError.TwoFactorRequired && !isChanged;
      var isDisabled = [EAuthenticateStatus.Loading, EAuthenticateStatus.Succeed].includes(authenticateStatus);
      return /*#__PURE__*/React.createElement("div", {
        className: styles['code_row']
      }, /*#__PURE__*/React.createElement(FormItem, {
        ref: this.codeField,
        id: "two_factor-code",
        numeric: true,
        label: "\u041F\u0440\u043E\u0432\u0435\u0440\u043E\u0447\u043D\u044B\u0439 \u043A\u043E\u0434 \u0438\u0437 \u0441\u043C\u0441",
        value: code,
        error: isError ? authenticateError : undefined,
        invalid: isError || isCodeInvalid,
        disabled: isDisabled,
        maxLength: 10,
        onKeyDown: this.handleCodeKeyDown,
        onValueChange: this.handleCodeValueChange
      }), codeSentDate ? /*#__PURE__*/React.createElement("div", {
        className: styles['code_timer']
      }, !codeResendAvailable ? /*#__PURE__*/React.createElement("span", null, "\u0412\u044B\u0441\u043B\u0430\u0442\u044C \u043A\u043E\u0434 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E \u0447\u0435\u0440\u0435\u0437 ", /*#__PURE__*/React.createElement(Timer, {
        start: codeSentDate,
        timeout: 60,
        onTimeout: this.handleTimeout
      }), ' ', "\u0441\u0435\u043A.") : /*#__PURE__*/React.createElement(Link, {
        href: "#",
        onClick: this.handleResendClick
      }, "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E")) : null);
    }
  }]);

  return TwoFactorView;
}(React.Component);